import PayDay from './PayDay';
export default PayDay;